module.exports = __webpack_public_path__ + "assets/img/kv-611c4355.png";